import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/E3_Hourglass.svg'

const E3Hourglass: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 12 12'} component={Icon} {...props} fill="currentColor" />
export default E3Hourglass
